import { on as onEvent } from "common/utils/ui/event";
import { track } from "jiffy-analytics";
import "./products-faq.scss";

const SHOWN_CLASS = "products-faq__faq-item--shown";

const initProductsFaq = () => {
  onEvent("click", ".js-products-faq-link", (_, $target) => {
    const $parent = $target.parentElement;
    $parent.classList.toggle(SHOWN_CLASS);

    track("faq_question_clicked", {
      interaction_type: $parent.classList.contains(SHOWN_CLASS) ? "expand" : "collapse",
      question: $target.textContent.trim()
    });
  });
};

export default initProductsFaq;
